var swiper = new Swiper.default('.swiper--main', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next--main',
    prevEl: '.swiper-button-prev--main'
  },
  pagination: {
    el: '.swiper-pagination--main',
    clickable: true
  },
});

var productSliders = document.querySelectorAll('.swiper--category');

productSliders.forEach(element => {
  var slidesCount = element.querySelectorAll('.swiper-slide')?.length,
      prevEl = element.parentElement.querySelector('.swiper-button-prev--category'),
      nextEl = element.parentElement.querySelector('.swiper-button-next--category');
  
  var swiper = new Swiper.default(element, {
    loop: slidesCount <= 2 ? false : true,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl
    },
    slidesPerView: 'auto', 
    centeredSlides: slidesCount <= 2 ? false : true,
    spaceBetween: 30,
    breakpoints: {
      1024: {
        loop: slidesCount <= 1 ? false : true
      },
      480: {
        loop: true,
        centeredSlides: true
      }
    }
  });
});

var galleryThumbs = new Swiper.default('.product .gallery-thumbs', {
  direction: "vertical",
  spaceBetween: 16,
  slidesPerView: 2,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.swiper-button-next--gallery',
    prevEl: '.swiper-button-prev--gallery',
  },
  breakpoints: {
    768: {
      direction: "horizontal",
      spaceBetween: 20,
    }
  }
});

var galleryTop = new Swiper.default('.gallery-top', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  thumbs: {
    swiper: galleryThumbs
  },
});